var _rect, _rect2, _circle, _path, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    transform: "translate(0 0.5)",
    fill: "#008080"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    transform: "translate(2.5 3)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 1.5,
    fill: "#008080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C6.067 9.5 4.5 10.8431 4.5 12.5H11.5C11.5 10.8431 9.933 9.5 8 9.5Z",
    fill: "#008080"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 5,
    width: 7,
    height: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 10,
    width: 7,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueid);
export default __webpack_public_path__ + "static/media/issueid.73221c24fa002d217d9c8ca532db0d8c.svg";
export { ForwardRef as ReactComponent };